import { Trans } from "@lingui/react/macro"
import React from "react"

import Paragraph from "../../../../design-system/paragraph"
import * as styles from "../footer-link/index.module.scss"

const FooterCookieSettings = () => {
  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault()
    window.Optanon?.ToggleInfoDisplay()
  }
  return (
    <button onClick={handleClick} type="button">
      <Paragraph variant="3" className={styles.footerLink}>
        <Trans>Cookie settings</Trans>
      </Paragraph>
    </button>
  )
}

export default FooterCookieSettings
